<template>
  <div class="wrapper">
    <div class="contentBox">
      <div class="actionBar">
        <el-input
          class="searchInput"
          size="small"
          placeholder="分组名称"
          v-model="searchCondition.paperGroupName"
          clearable
        >
        </el-input
        >&emsp;
        <el-input
          class="searchInput"
          size="small"
          placeholder="考试名称"
          v-model="searchCondition.testName"
          clearable
        >
        </el-input
        >&emsp;
        <el-button
          type="primary"
          size="small"
          icon="el-icon-search"
          @click="getPaperSettingList()"
          >查询
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          class="saveBar"
          @click="dialogFormVisible = true"
        >
          添加
        </el-button>
      </div>
      <el-dialog
        title="添加分组"
        :visible.sync="dialogFormVisible"
        :append-to-body="true"
        @closed="reset('form')"
      >
        <el-form :model="form" :label-width="formLabelWidth">
          <el-form-item label="报名来源 :">
            <el-radio-group v-model="form.source" @change="clearTestId()">
              <el-radio :label="0">专业报名</el-radio>
              <el-radio :label="1">简易报名</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="考试名称 :">
            <el-select v-model="form.testId" placeholder="请选择">
              <el-option
                v-for="item in paperApplyListComputed"
                :key="item.testName"
                :label="item.testName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分组名称 :">
            <el-input
              v-model="form.paperGroupName"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="分组描述 :">
            <el-input
              v-model="form.paperGroupDec"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="添加审核老师 :">
            <el-select
              v-model="form.auditTeacher"
              multiple
              placeholder="请选择"
            >
              <el-option
                v-for="item in teacherOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="(dialogFormVisible = false), reset('form')"
            >取 消
          </el-button>
          <el-button type="primary" @click="editPaperSetting()"
            >确 定
          </el-button>
        </div>
      </el-dialog>
      <div class="tableContainer">
        <Table :columns="columns" :data="paperSettingList" border>
          <template slot-scope="{ row, index }" slot="action">
            <div>
              <el-link type="primary" @click="getPaperSettingDetail(row.id)"
                >编辑 </el-link
              >&emsp;<el-link type="primary" @click="showScoreItems(row.id)"
                >编辑得分项 </el-link
              >&emsp;
              <el-link type="primary" @click="delPaperGroup(row.id)"
                >删除 </el-link
              >&emsp;
              <el-link type="primary" @click="getReservationTimeList(row)"
                >预约时间</el-link
              >
            </div>
          </template>
        </Table>

        <!--分页-->

        <el-row>
          <el-col :span="24">
            <div class="pagination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="paginations.page_index"
                :page-sizes="paginations.page_sizes"
                :page-size.sync="paginations.page_size"
                :layout="paginations.layout"
                :total="paginations.total"
              >
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>

      <el-dialog
        title="预约时间"
        :visible.sync="dialogTableVisible"
        append-to-body
      >
        <el-button type="primary" @click="dialogAddReservationTime = true"
          >添加时间段</el-button
        >
        <br />
        <el-table :data="reservationTimeList">
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            property="canBookedNumber"
            label="可预约人数"
          ></el-table-column>
          <el-table-column
            property="bookedNumber"
            label="已预约人数"
          ></el-table-column>
          <el-table-column property="bookedDate" label="日期"></el-table-column>
          <el-table-column
            property="startTime"
            label="开始时间"
          ></el-table-column>
          <el-table-column
            property="endTime"
            label="结束时间"
          ></el-table-column>
          <el-table-column label="操作" style="width: 200px">
            <template slot-scope="scope">
              <el-button @click="getReservationTimeDetail(scope.row)"
                >编辑</el-button
              >
              <el-button>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <el-col :span="24">
            <div class="pagination">
              <el-pagination
                @size-change="reservationHandleSizeChange"
                @current-change="reservationHandleCurrentChange"
                :current-page.sync="reservationPaginations.page_index"
                :page-sizes="reservationPaginations.page_sizes"
                :page-size.sync="reservationPaginations.page_size"
                :layout="reservationPaginations.layout"
                :total="reservationPaginations.total"
              >
              </el-pagination>
            </div>
          </el-col>

          <el-dialog
            title="添加预约时间"
            :visible.sync="dialogAddReservationTime"
            append-to-body
            @closed="reset('reservaDataSubmit')"
          >
            <el-form :model="reservaDataSubmit" :label-width="formLabelWidth">
              <el-form-item label="可预约人数">
                <el-input
                  v-model="reservaDataSubmit.canBookedNumber"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="日期">
                <el-date-picker
                  v-model="reservaDataSubmit.bookedDate"
                  type="date"
                  value-format="YYYY:MM:DD"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="时间">
                <el-time-picker
                  is-range
                  v-model="applyTimeRange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围"
                  format="HH:mm:ss"
                  value-format="HH:mm:ss"
                >
                </el-time-picker>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogAddReservationTime = false"
                >取 消</el-button
              >
              <el-button type="primary" @click="editReservationTime()"
                >确 定</el-button
              >
            </div>
          </el-dialog>
        </el-row>
      </el-dialog>
      <el-dialog
        title="配置得分项"
        :visible.sync="scoreItemsData.ifShow"
        append-to-body
        v-loading="scoreItemsData.ifRequesting"
      >
        <div
          class="scoreItemBar"
          v-for="(item, index) in scoreItemsData.scoreItemList"
          :key="'scoreItem' + index"
          style=""
        >
          <el-input
            class="scoreName"
            v-model="item.scoreItemName"
            size="small"
            placeholder="得分项名称"
            style=""
          ></el-input>
          <el-input
            class="scoreValue"
            size="small"
            placeholder="总得分"
            v-model="item.maxScore"
            min="1"
            type="number"
            style=""
          ></el-input>
          <div class="actBox" style="">
            <i
              class="el-icon-error"
              style=""
              v-if="index"
              @click="scoreItemsData.scoreItemList.splice(index, 1)"
            ></i>
          </div>
        </div>
        <el-button
          type="primary"
          size="small"
          @click="
            scoreItemsData.scoreItemList.push({
              scoreItemName: '',
              maxScore: 1,
            })
          "
          >添加得分项</el-button
        >
        <div slot="footer" class="dialog-footer">
          <el-button @click="scoreItemsData.ifShow = false">取 消</el-button>
          <el-button type="primary" @click="submitScoreItem()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getPaperSettingList,
  getPaperApplyList,
  delPaperSetting,
  getPaperSettingDetail,
  editPaperSetting,
  getReservationTimeList,
  editReservationTime,
  getReservationTimeDetail,
  getScoreItem,
  saveScoreItem,
} from "@/api/paper.js";

export default {
  data() {
    return {
      teacherOptions: [],
      applyTimeRange: [new Date(2020, 1, 1, 9, 0), new Date(2020, 1, 1, 18, 0)],
      dialogTableVisible: false,
      dialogAddReservationTime: false,
      reservationTimeList: [],
      paginations: {
        page_index: 1, //当前页
        page_size: 30, //每页多少条
        total: 30,
        page_sizes: [10, 15, 30, 50],
        layout: "total,sizes, prev, pager, next,jumper",
      },
      reservationPaginations: {
        page_index: 1, //当前页
        page_size: 30, //每页多少条
        total: 30,
        page_sizes: [10, 15, 30, 50],
        layout: "total,sizes, prev, pager, next,jumper",
      },
      searchCondition: {
        pageSize: 30,
        jumpPage: 1,
        paperGroupName: "",
        testName: "",
      },
      searchReservationData: {
        id: "",
        pageSize: 30,
        jumpPage: 1,
      },
      reservaDataSubmit: {
        id: "",
        paperGroupId: "",
        canBookedNumber: "",
        bookedDate: "",
        startTime: "",
        endTime: "",
        applyTimeRange: [],
      },
      columns: [
        // {
        //   type: "selection",
        //   width: 60,
        //   align: "center",
        //   key: "choose",
        // },
        {
          title: "序号",
          type: "index",
          width: 70,
          fixed: "left",
        },
        {
          title: "论文分组名称",
          key: "paperGroupName",
          minWidth: 120,
        },

        {
          title: "考试名称",
          key: "testName",
          minWidth: 180,
        },
        {
          title: "渠道来源",
          key: "source",
          minWidth: 90,
        },
        {
          title: "创建时间",
          key: "createTime",
          width: 160,
        },
        {
          title: "论文审核人",
          key: "auditTeacher",
          minWidth: 100,
        },

        {
          title: "操作",
          slot: "action",
          width: 190,
          align: "center",
        },
      ],
      paperSettingList: [],
      paperApplyList: [],
      paperApplyListSimple: [],
      paperApplyListProfessional: [],
      dialogFormVisible: false,
      form: {
        id: "",
        name: "",
        testId: "",
        paperGroupName: "",
        paperGroupDec: "",
        auditTeacher: "",
        source: 0,
        testName: "",
      },
      formLabelWidth: "120px",
      scoreItemsData: {
        ifShow: false,
        scoreItemList: [],
        paperGroupId: 0,
        ifRequesting: false,
      },
    };
  },
  computed: {
    paperApplyListComputed() {
      return [this.paperApplyListProfessional, this.paperApplyListSimple][
        this.form.source
      ];
    },
  },
  watch: {
    applyTimeRange(val) {
      console.log("时间变了", val);
      [this.reservaDataSubmit.startTime, this.reservaDataSubmit.endTime] = val;
    },
  },
  created() {},
  mounted() {
    this.getPaperApplyList();
    this.getPaperSettingList();
  },
  methods: {
    submitScoreItem() {
      console.log(this.scoreItemsData);
      if (
        this.scoreItemsData.scoreItemList.length &&
        this.scoreItemsData.scoreItemList.every(
          (item) => item.maxScore && item.scoreItemName
        )
      ) {
        saveScoreItem({
          paperGroupId: this.scoreItemsData.paperGroupId,
          scoreItemList: this.scoreItemsData.scoreItemList,
        }).then((data) => {
          this.$message.success("保存成功");
          Object.assign(
            this.scoreItemsData,
            this.$options.data().scoreItemsData
          );
        });
      } else {
        this.$alert("请确保每项得分项名称和分数都填写完毕");
      }
    },
    showScoreItems(paperGroupId) {
      this.scoreItemsData.ifRequesting = true;
      getScoreItem({ paperGroupId }).then((data) => {
        this.scoreItemsData.scoreItemList = data;
        this.scoreItemsData.ifRequesting = false;
      });
      Object.assign(this.scoreItemsData, {
        ifShow: true,
        paperGroupId: paperGroupId,
      });
    },
    handleSizeChange(page_size) {
      console.log(`每页 ${page_size} 条`);
      this.paginations.page_size = page_size;
      this.searchCondition.pageSize = page_size;
      this.getPaperSettingList();
    },
    handleCurrentChange(page) {
      console.log(`当前页: ${page}`);
      this.paginations.page_index = page;
      this.searchCondition.jumpPage = page;
      this.getPaperSettingList();
    },
    reservationHandleSizeChange(page_size) {
      console.log(`每页 ${page_size} 条`);
      this.searchReservationData.page_size = page_size;
      this.searchReservationData.pageSize = page_size;
      this.getReservationTimeList();
    },
    reservationHandleCurrentChange(page) {
      console.log(`当前页: ${page}`);
      this.searchReservationData.page_index = page;
      this.searchReservationData.jumpPage = page;
      this.getReservationTimeList();
    },

    getPaperSettingList() {
      console.log("筛选条件searchCondition=", this.searchCondition);
      getPaperSettingList(this.searchCondition).then((data) => {
        console.log("paperSettingList结果", data);
        this.paperSettingList = data.records;
        this.paginations.total = data.total;
      });
    },

    getPaperApplyList() {
      getPaperApplyList({ source: 0 }).then((data) => {
        console.log("paperApplyListPro结果", data);
        this.paperApplyListProfessional = data;
      });
      getPaperApplyList({ source: 1 }).then((data) => {
        console.log("paperApplyListSimple结果", data);
        this.paperApplyListSimple = data;
      });
    },

    editPaperSetting() {
      console.log("要提交的data", this.form);
      //  this.form.auditTeacher =this.form.auditTeacher.join(',')
      let postData = {};
      Object.assign(postData, this.form);
      postData.auditTeacher = postData.auditTeacher.join(",");
      editPaperSetting(postData).then(() => {
        this.$message.success("保存成功");
        this.getPaperSettingList();
      });
      this.dialogFormVisible = false;
    },

    delPaperGroup(id) {
      console.log(id);
      this.$confirm("确定删除当前论文分组吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delPaperSetting({ id: id }).then(() => {
            this.$Message.success("删除成功");
            this.getPaperSettingList();
          });
          //
          // this.$message({
          //   type: 'success',
          //   message: '删除成功!'
          // });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    getPaperSettingDetail(id) {
      getPaperSettingDetail({ id: id }).then((data) => {
        console.log("detail", data);
        this.form = data;
        this.dialogFormVisible = true;
      });
    },

    reset(form) {
      console.log("清空form后的form在这里", this.form, this.reservaDataSubmit);
      Object.assign(this.$data[form], this.$options.data()[form]);
      this.applyTimeRange = [
        new Date(2020, 1, 1, 9, 0),
        new Date(2020, 1, 1, 18, 0),
      ];
    },

    clearTestId() {
      console.log("清除testId进来了");
      this.form.testId = null;
    },

    getReservationTimeList(row) {
      this.dialogTableVisible = true;
      (this.searchReservationData.id = row.id),
        (this.reservaDataSubmit.paperGroupId = row.id),
        getReservationTimeList(this.searchReservationData).then((data) => {
          console.log("detail", data);
          this.reservationTimeList = data.records;
          this.reservationPaginations.total = data.total;
        });
    },
    editReservationTime() {
      editReservationTime(this.reservaDataSubmit).then(() => {
        console.log("保存预约时间", data);
        this.$message.success("保存成功");
      });
      this.dialogAddReservationTime = false;
      this.getReservationTimeList();
    },
    getReservationTimeDetail(item) {
      getReservationTimeDetail({ id: item.id }).then((data) => {
        this.reservaDataSubmit = data;
        this.applyTimeRange = [
          this.reservaDataSubmit.startTime,
          this.reservaDataSubmit.endTime,
        ];
        console.log("详情", this.reservaDataSubmit);
        console.log("reservaDataSubmit", this.reservaDataSubmit);
      });

      this.dialogAddReservationTime = true;
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  background: #fff;
  font-size: 12px;
  margin: 15px;

  .contentBox {
    background: #fff;
    padding: 20px;

    .actionBar {
      .searchInput {
        width: 20%;
      }

      .saveBar {
        display: inline-block;
        float: right;
      }
    }

    .tableContainer {
      background: #fff;
      padding-top: 20px;
    }

    /deep/ .el-table {
      background-color: #000;
      border-bottom: 1px;
    }
  }
}
.scoreItemBar {
  display: flex;
  margin: 15px 0;
  .scoreName {
    flex: 1;
  }
  .scoreValue {
    width: 80px;
    margin: 0 10px;
  }
  .actBox {
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-icon-error {
      font-size: 32px;
      cursor: pointer;
      &:hover {
        color: #618afd;
      }
    }
  }
}
</style>
